import { defer } from 'react-router-dom'
import { logger, getQueryStringParamsFromStringUrl } from '$utils'
import { isAppStateReady } from 'src/state/store'
import usePayrollStore from '../store'
import { getDateRangeFromQueryStringOrAppStore } from '../../../../common/helpers/queryString'

export default async function loader({ request: { url } }) {
  const queryParams = getQueryStringParamsFromStringUrl(url)

  logger.debug(
    '[loader] About to await AppState being ready in PaySummary loader'
  )
  await isAppStateReady()
  logger.debug('[loader] AppState should now be ready in PaySummary loader')

  const { startDateTime, endDateTime } =
    getDateRangeFromQueryStringOrAppStore(queryParams)

  const getClockins = usePayrollStore
    .getState()
    .getClockins(startDateTime, endDateTime)

  const getRosteredShifts = usePayrollStore
    .getState()
    .getRosteredShifts(startDateTime, endDateTime)

  const getStaffMembers = usePayrollStore.getState().getStaffMembers()

  const getPackages = usePayrollStore.getState().getPackages()

  return defer({
    data: Promise.all([
      getClockins,
      getRosteredShifts,
      getStaffMembers,
      getPackages,
    ])
      .then(() => true)
      .catch((error) => {
        logger.error('Pay Summary Promise.all error', error)
        return false
      }),
  })
}
